import { FWNElement } from './bases/FWNElement'

class PlayerElement extends FWNElement {
  height = '100%'
  width = '100%'
  aspectRatio = '16 / 9'

  override render(): void {
    const params = {
      height: this.height,
      width: this.width,
      ...this.getAttributes(),
    }

    import('@embed/playerRender').then(({ playerRender }) => {
      if (this.shadowRoot) {
        const computedAspectRatio =
          parseFloat(getComputedStyle(this).aspectRatio.split(' ')[0]) /
          parseFloat(getComputedStyle(this).aspectRatio.split(' ')[2])

        this.setSpaceReservingStyle(
          'aspect-ratio',
          computedAspectRatio
            ? computedAspectRatio.toString()
            : this.aspectRatio,
        )

        playerRender({
          target: this.shadowRoot,
          widgetId: this.widgetId,
          widgetParams: params,
        })
      }
    })
  }
}

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'fw-player': Record<string, string>
    }
  }
}

if (!customElements.get('fw-player')) {
  customElements.define('fw-player', PlayerElement)
}
